<template>
  <div class="admin-open-orders">
    <header-title title="Cuentas Abiertas"></header-title>

    <v-container fluid class="pl-0 pr-0">
      <v-row align="start">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            outlined
            dense
            label="Buscar Mesa"
            v-model="search"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            outlined
            dense
            v-model="selectedZone"
            :items="filterZoneItems"
            item-text="name"
            item-value="id"
            label="Zona"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            outlined
            dense
            v-model="selectedState"
            :items="filterStateItems"
            label="Estado"
          ></v-select>
        </v-col>
        <v-col cols="12" justify="center" sm="6" md="3" lg="2">
          <v-btn
            dense
            outlined
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col class="printer-select-box" md="4">
        <v-select
          v-model="selectedPrinters"
          label="Impresora Marchar Segundos"
          :items="printers"
          item-text="name"
          item-value="url"
          multiple
          chips
          deletable-chips
          outlined
        ></v-select>
      </v-col>
      <v-col class="printer-select-box" md="4">
        <v-select
          v-model="selectedPrinterTicket"
          label="Impresora Ticket"
          :items="printers"
          item-text="name"
          item-value="url"
          outlined
          return-object
        ></v-select>
      </v-col>
      <v-col class="printer-select-box" md="4">
        <v-select
          v-model="selectedDrawer"
          label="Cajón"
          :items="cashDrawers"
          item-text="name"
          item-value="url"
          outlined
          return-object
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="auto">
        <button
          class="admin-reset-filters"
          @click="openChangeTableDialog"
          :style="adminResetFiltersTheme"
        >
          Cambio de mesa
        </button>
      </v-col>
      <v-col md="auto">
        <v-btn
          @click="openReprintDialog()"
          class="notification-button reprint-btn printer-btn"
          dark
          text
        >
          <img width="25" src="@/assets/images/printer_icon.png" alt="Print" />
          <span
            class="total-quantity"
            :class="printingErrorsPresent ? 'errors-red' : 'errors-green'"
          >
            {{ totalPrintingErrors }}
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="ml-2 mobile-view-padding">
      <v-col md="4" sm="5" cols="12">
        <v-row class="mt-2 align-items-center justify-content-around">
          <div class="mb-div-width mb-1 mobile-flex-div">
            <span class="text-caption first">Pagados</span>
            <v-avatar
              :color="colors.GREEN.color"
              size="36"
              class="white--text ml-1 mr-1 elevation-5"
            >
              {{ getSize(paidOrders) }}
            </v-avatar>
          </div>
          <div class="mb-div-width mb-1 mobile-flex-div">
            <span class="text-caption">Pagando</span>
            <v-avatar
              :color="colors.ORANGE.color"
              size="36"
              class="white--text ml-1 mr-1 elevation-5"
            >
              {{ payingOrders }}
            </v-avatar>
          </div>
          <div class="mb-div-width mobile-flex-div">
            <span class="text-caption">Sin pagar</span>
            <v-avatar
              :color="colors.RED.color"
              size="36"
              class="white--text ml-1 mr-2 elevation-5"
            >
              {{ withoutPayingOrders }}
            </v-avatar>
          </div>
        </v-row>
      </v-col>
      <v-col md="6" sm="7" cols="12">
        <v-row class="mt-2 align-items-center justify-content-around">
          <div class="mb-div-width mobile-flex-div">
            <span class="text-caption first">Mesa con Segundo</span>
            <v-avatar size="36" class="ml-1 mr-2 elevation-5 oval1 red_oval">
              {{ tableWithMainDish }}
            </v-avatar>
          </div>
          <div class="mb-div-width mobile-flex-div">
            <span class="text-caption">Segundos Marchado</span>
            <v-avatar size="36" class="ml-1 mr-2 elevation-5 oval1 blue_oval"
              >{{ getPrintedOrder }}
            </v-avatar>
          </div>
          <div class="mb-div-width mobile-flex-div">
            <span class="text-caption">Postre</span>
            <v-avatar
              size="36"
              class="ml-1 mr-2 elevation-5 oval1 violetblue_oval"
            >
              {{ postresCount }}
            </v-avatar>
          </div>
        </v-row>
      </v-col>
    </v-row>

    <br />
    <br />

    <v-alert v-if="ordersPending.length === 0" type="info" outlined prominent
      >No hay cuentas abiertas!
    </v-alert>

    <OpenOrdersByZone
      v-if="ordersPending.length > 0"
      :selectedState="selectedState"
      :selected-printers="selectedPrinters"
      :selectedPrinterTicket="selectedPrinterTicket"
      :orders="ordersGrouped"
      :selectedZone="selectedZone"
      :search="search"
      :selectedDrawer="selectedDrawer"
      :cashDrawers="cashDrawers"
    />

    <ChangeTableDialog ref="changeTableDialogRef"></ChangeTableDialog>
    <reprint-dialog group-order-id="open-orders" ref="reprintDialogRef" />
  </div>
</template>

<script>
import { paymentsCollection, deletePayment } from "@/collections/payments";
import { firestoreTimestamp } from "@/firebaseConfig";
import { printersCollection } from "@/collections/printers";
import { printerErrorsCollection } from "@/collections/printerErrors";
import { qrZoneCollection } from "@/collections/qrZone";
import OpenOrdersByZone from "@/components/admin/order/OpenOrdersByZone";
import ChangeTableDialog from "@/components/admin/order/ChangeTableDialog";
import { size } from "lodash";
import ReprintDialog from "@/components/admin/printer/ReprintDialog.vue";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import moment from "moment";
import { mapMutations } from "vuex";
import { ordersCollection, updateOrder } from "@/collections/orders";
import {
  ordersTotalByTableCollection,
  updateOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { qrCollection } from "@/collections/qrs";
import { cashDrawersCollection } from "@/collections/cashDrawer";

let printersMarcharSegundos = window.localStorage.getItem(
  "printers_marchar_segundos"
);
let interval = null;
const GREEN = {
  color: "#4caf50",
  name: "green",
  value: 0
};
const ORANGE = {
  color: "#fb8c00",
  name: "orange",
  value: 1
};
const GREY = {
  color: "#9e9e9e",
  name: "gret",
  value: 3
};
const RED = {
  color: "#ff5252",
  name: "red",
  value: 4
};
const BLUE = {
  color: "#3f48cc",
  name: "blue",
  value: 5
};
const VIOLETBLUE = {
  color: "#a349a4",
  name: "violetblue",
  value: 5
};
export default {
  name: "OrdersOpen",
  components: {
    OpenOrdersByZone,
    ChangeTableDialog,
    ReprintDialog,
    HeaderTitle
  },
  data() {
    return {
      colors: {
        GREEN,
        ORANGE,
        GREY,
        RED,
        BLUE,
        VIOLETBLUE
      },
      orders: [],
      printers: [],
      selectedPrinters: printersMarcharSegundos
        ? JSON.parse(printersMarcharSegundos)
        : [],
      search: "",
      selectedState: -1,
      selectedZone: "0",
      filterStateItems: [
        {
          text: "Todos",
          value: -1
        },
        {
          text: "Pagados",
          value: 0
        },
        {
          text: "Pagando",
          value: 1
        },
        {
          text: "Sin pagar",
          value: 2
        }
      ],
      qrCollection: [],
      qrZoneCollection: [],
      ordersTotalByTableCollection: [],
      printerErrors: [],
      paymentsCollection: [],
      cashDrawers: []
    };
  },
  firestore() {
    return {
      orders: ordersCollection
        .where("isOpen", "==", true)
        .orderBy("time", "desc"),
      qrCollection: qrCollection,
      qrZoneCollection: qrZoneCollection,
      printers: printersCollection.where("active", "==", true),
      ordersTotalByTableCollection: ordersTotalByTableCollection,
      printerErrors: printerErrorsCollection
        .where("status", "==", true)
        .where("groupId", "==", "open-orders"),
      paymentsCollection: paymentsCollection.where("payment_on", "==", null),
      cashDrawers: cashDrawersCollection.where("active", "==", true)
    };
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(interval);
    next();
  },
  computed: {
    selectedPrinterTicket: {
      get() {
        return this.$store.state.selectedPrinters.openAccount;
      },
      set(value) {
        this.$store.commit("setSelectedPrinters", { openAccount: value });
      }
    },
    selectedDrawer: {
      get() {
        return this.$store.state.selectedDrawer;
      },
      set(value) {
        this.$store.commit("setSelectedDrawer", value);
      }
    },
    filterZoneItems() {
      return [{ id: "0", name: "Todos" }, ...this.qrZoneCollection];
    },
    ordersPending() {
      let self = this;
      let _orders = [...self.orders];
      _orders = _orders.filter(order => {
        return (
          order.metadata &&
          order.tableQR?.toLowerCase()?.includes(this.search.toLowerCase())
        );
      });

      if (this.selectedZone !== "0") {
        _orders = _orders.filter(order => {
          let table = self.qrCollection.find(x => order.tableQR === x.table);
          return table ? table.zone_id === self.selectedZone : false;
        });
      }

      return _orders;
    },
    ordersGrouped() {
      return this.arrayGroupBy(this.ordersPending, "tableQR");
    },
    paidOrders() {
      let self = this;
      let paidOrder = [];
      let _orders = [...this.orders];
      if (_orders) {
        _orders.forEach(order => {
          let table = self.qrCollection.find(x => order.tableQR === x.table);
          let orderByTableTotal = null;

          if (table) {
            orderByTableTotal = self.ordersTotalByTableCollection.find(
              x => x.tableQR === table.table
            );
          }

          if (orderByTableTotal && orderByTableTotal.remaining === 0) {
            paidOrder.push(orderByTableTotal);
          }
        });
      }
      return paidOrder ? this.arrayGroupBy(paidOrder, "tableQR") : [];
    },
    payingOrders() {
      let self = this;
      let payingOrder = [];
      let _orders = [...this.orders];
      if (_orders) {
        _orders.forEach(order => {
          let table = self.qrCollection.find(x => order.tableQR === x.table);
          let orderByTableTotal = null;
          if (table) {
            let orders = this.ordersGrouped
              ? this.ordersGrouped[table.table]
              : "";
            let orderTotal = null;
            if (orders) {
              orderTotal = orders
                .map(
                  el =>
                    el.quantity * el.price + this.totalWithAdditionalCharge(el)
                )
                .reduce(
                  (accumulator, currentValue) => accumulator + currentValue
                );
              orderByTableTotal = self.ordersTotalByTableCollection.find(
                x => x.tableQR === table.table
              );
            }

            if (
              orderByTableTotal &&
              parseFloat(orderTotal).toFixed(2) !==
                parseFloat(orderByTableTotal.remaining).toFixed(2) &&
              orderByTableTotal.remaining !== 0
            ) {
              payingOrder.push(orderByTableTotal);
            }
          }
        });
      }
      return size(this.arrayGroupBy(payingOrder, "tableQR"));
    },
    withoutPayingOrders() {
      let self = this;
      let withoutPayingOrder = [];
      let _orders = [...this.orders];
      if (_orders) {
        _orders.forEach(order => {
          let table = self.qrCollection.find(x => order.tableQR === x.table);
          let orderByTableTotal = null;
          if (table) {
            let orders = this.ordersGrouped
              ? this.ordersGrouped[table.table]
              : "";
            let orderTotal = null;
            if (orders) {
              orderTotal = orders
                .map(
                  el =>
                    el.quantity * el.price + this.totalWithAdditionalCharge(el)
                )
                .reduce(
                  (accumulator, currentValue) => accumulator + currentValue
                );
              orderByTableTotal = self.ordersTotalByTableCollection.find(
                x => x.tableQR === table.table
              );
            }

            if (
              orderByTableTotal &&
              parseFloat(orderTotal).toFixed(2) ===
                parseFloat(orderByTableTotal.remaining).toFixed(2)
            ) {
              withoutPayingOrder.push(orderByTableTotal);
            }
          }
        });
      }
      return size(this.arrayGroupBy(withoutPayingOrder, "tableQR"));
    },
    tableWithMainDish() {
      let orders = this.orders.filter(x => {
        if (
          !x.isMenuGroupProduct &&
          x.canBeMainCourse === true &&
          !x.canBeShared
        ) {
          return x;
        }
      });

      let printedOrder = orders.filter(x => {
        if (!x.isPrinted && !x.isDelivered) {
          return x;
        }
      });
      return (
        size(this.arrayGroupBy(printedOrder, "tableQR")) +
        this.tableWithMainDishMenuGroup
      );
    },
    tableWithMainDishMenuGroup() {
      let menuGroup = this.orders.filter(item => item.isMenuGroupProduct);
      let orders = [];
      menuGroup.forEach(x => {
        x.maincourse.forEach(item => {
          item.tableQR = x.tableQR;
          orders.push(item);
        });
      });

      let printedOrder = orders.filter(x => {
        if (!x.isPrinted) {
          return x;
        }
      });
      return size(this.arrayGroupBy(printedOrder, "tableQR"));
    },
    postresCount() {
      const { dessert } = this.$store.state.productTypeIds;

      let dessertsProducts = this.orders.filter(item => {
        if (item.product_type_id === dessert) {
          return item;
        }
      });

      let groupDesertProduct = this.arrayGroupBy(dessertsProducts, "tableQR");
      let tableOrders = [];
      for (const prop in groupDesertProduct) {
        this.orders.forEach(item => {
          if (item.tableQR === prop) {
            tableOrders.push(item);
          }
        });
      }

      let postresFilter = tableOrders.filter(item => {
        if (item.isDeliveredMainCourse) {
          return item;
        }
      });
      return (
        size(this.arrayGroupBy(postresFilter, "tableQR")) +
        this.postresCountMenuGroup
      );
    },
    postresCountMenuGroup() {
      let menuGroup = this.orders.filter(item => item.isMenuGroupProduct);
      let dessertsProducts = [];
      let orders = [];
      menuGroup.forEach(x => {
        x.desserts.forEach(item => {
          item.tableQR = x.tableQR;
          dessertsProducts.push(item);
          orders.push(item);
        });
        x.maincourse.forEach(item => {
          item.tableQR = x.tableQR;
          orders.push(item);
        });
      });

      let groupDesertProduct = this.arrayGroupBy(dessertsProducts, "tableQR");
      let tableOrders = [];

      for (const prop in groupDesertProduct) {
        orders.forEach(item => {
          if (item.tableQR === prop) {
            tableOrders.push(item);
          }
        });
      }

      let postresFilter = tableOrders.filter(item => {
        if (item.isPrinted && item.isDeliveredMainCourse) {
          return item;
        }
      });
      return size(this.arrayGroupBy(postresFilter, "tableQR"));
    },
    getPrintedOrder() {
      const { dessert } = this.$store.state.productTypeIds;

      let menuGroup = this.orders.filter(item => item.isMenuGroupProduct);

      let dessertsProducts = [];
      let orders = [];
      menuGroup.forEach(x => {
        x.desserts.forEach(item => {
          item.tableQR = x.tableQR;
          dessertsProducts.push(item);
          orders.push(item);
        });
        x.maincourse.forEach(item => {
          item.tableQR = x.tableQR;
          orders.push(item);
        });
        x.drinks.forEach(item => {
          item.tableQR = x.tableQR;
          orders.push(item);
        });
        x.starters.forEach(item => {
          item.tableQR = x.tableQR;
          orders.push(item);
        });
      });

      let allOrders = [...orders, ...this.orders];

      let disersOrders = allOrders.filter(item => {
        if (item.product_type_id === dessert && item.isPrinted) {
          return item;
        }
      });
      let tablesDessert = [];
      let groupDesertProduct = this.arrayGroupBy(disersOrders, "tableQR");
      for (let prop in groupDesertProduct) {
        tablesDessert.push(prop);
      }

      let allDesertTableOrders = allOrders.filter(item => {
        if (
          tablesDessert.includes(item.tableQR) &&
          item.isDeliveredMainCourse
        ) {
          return item;
        }
      });

      // eslint-disable-next-line no-unused-vars
      let desertOrderTableSize = size(
        this.arrayGroupBy(allDesertTableOrders, "tableQR")
      );

      let notPrintedOrders = allOrders.filter(item => {
        if (!item.isPrinted && !item.isMenuGroupProduct) {
          return item;
        }
      });

      let desertsTables = this.arrayGroupBy(allDesertTableOrders, "tableQR");
      let desertOnlyTableNames = [];
      for (let prop in desertsTables) {
        desertOnlyTableNames.push(prop);
      }
      notPrintedOrders = notPrintedOrders.filter(item => {
        if (!desertOnlyTableNames.includes(item.tableQR)) {
          return item;
        }
      });

      let notPrintedOrderSize = size(
        this.arrayGroupBy(notPrintedOrders, "tableQR")
      );

      let allOrderSize = size(this.arrayGroupBy(allOrders, "tableQR"));

      let isMainCourseCheckedTables = allOrders.filter(item => {
        if (item.isDeliveredMainCourse) {
          return item;
        }
      });
      let isMainCourseCheckedTableSize = size(
        this.arrayGroupBy(isMainCourseCheckedTables, "tableQR")
      );

      let countPrinted =
        allOrderSize - (isMainCourseCheckedTableSize + notPrintedOrderSize);

      return countPrinted > 0 ? countPrinted : 0;
    },
    printingErrorsPresent() {
      return !!(this.printerErrors && this.printerErrors.length);
    },
    totalPrintingErrors() {
      if (this.printerErrors && this.printerErrors.length > 9) {
        return "+9";
      } else if (this.printerErrors && this.printerErrors.length) {
        return this.printerErrors.length;
      } else {
        return "";
      }
    },
    getTableCloseTimer() {
      let time =
        this.settings &&
        this.settings.tableCloseTimer &&
        this.settings.tableCloseTimer !== "NO"
          ? this.settings.tableCloseTimer.split(" ")
          : [];
      return time;
    }
  },
  watch: {
    selectedPrinters(printers) {
      localStorage.setItem(
        "printers_marchar_segundos",
        JSON.stringify(printers)
      );
    }
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    ...mapMutations({
      setSelectedPrinters: "setSelectedPrinters"
    }),
    resetFilters() {
      this.search = "";
      this.selectedZone = "";
    },
    openChangeTableDialog() {
      this.$refs.changeTableDialogRef.openDialog();
    },
    openReprintDialog() {
      if (this.printingErrorsPresent) {
        this.$refs.reprintDialogRef.open();
      }
    },
    getSize(paidOrder) {
      return size(paidOrder);
    },
    startTimer() {
      interval = setInterval(async () => {
        // eslint-disable-next-line no-unused-vars
        for (const [key, tableDetails] of Object.entries(this.paidOrders)) {
          let orderTotal = this.ordersTotalByTableCollection.find(
            x => x.tableQR === key
          );
          let _orders = this.orders.filter(order => order.tableQR === key);
          console.log("orders", _orders);
          if (orderTotal) {
            let currentTime = moment();
            let paymentTime = moment(orderTotal?.time?.seconds * 1000);
            let secDiff =
              this.getTableCloseTimer[1] === "min"
                ? currentTime.diff(paymentTime, "minutes")
                : currentTime.diff(paymentTime, "seconds");
            if (
              this.getTableCloseTimer.length &&
              secDiff >= parseInt(this.getTableCloseTimer[0])
            ) {
              await this.closePaidOrders(_orders, key);
            }
          }
        }
      }, 1000);
    },
    async closePaidOrders(_orders, key) {
      try {
        let now = moment().format();
        let time = firestoreTimestamp.fromDate(new Date());
        let pairOrder = _orders;
        // eslint-disable-next-line no-unused-vars
        for (const [tableQR, tableDetails] of Object.entries(this.paidOrders)) {
          if (key === tableQR) {
            if (pairOrder.length) {
              pairOrder.forEach(async item => {
                try {
                  if (item.metadata) {
                    // eslint-disable-next-line no-unused-vars
                    for (const [quantity, metadata] of Object.entries(
                      item.metadata
                    )) {
                      item.metadata[quantity].isPaid = true;
                    }
                  }
                  item.isOpen = false;
                  item.orderClosedAt = now;
                  await updateOrder(item.id, item);
                } catch (error) {
                  this.setlogError(
                    "update_order",
                    "Obtained error message in closePaidOrders()",
                    error.stack,
                    this.$options.name
                  );
                }
              });
            }
          } else {
            return;
          }
        }
        let payments = this.arrayGroupBy(this.paymentsCollection, "tableQR")[
          this.table
        ];

        // Remove unpaid payment requests
        payments
          ? payments.forEach(async payment => {
              try {
                await deletePayment(payment.id);
              } catch (error) {
                this.setlogError(
                  "delete_payment",
                  "Obtained error message in closePaidOrders()",
                  error.stack,
                  this.$options.name
                );
              }
            })
          : "";
        let orderTotal = this.ordersTotalByTableCollection.find(
          x => x.tableQR === key
        );
        if (orderTotal) {
          orderTotal.remaining = 0;
          orderTotal.time = time;
          await updateOrderTotalByTable(key, orderTotal);
        }
      } catch (error) {
        this.setlogError(
          "update_order_total_by_table",
          "Obtained error message in closePaidOrders()",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style scoped lang="scss">
.printer-btn {
  height: 46px !important;
  margin-top: 9px !important;
}
@media screen and (max-width: 767px) {
  .v-expansion-panel-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .v-expansion-panel-header__icon {
    margin-top: 10px;
  }
}

.oval1 {
  border-radius: 100%;
  width: 36px !important;
  height: 36px !important;
  background: #fff;
}
.red_oval {
  position: relative;
  width: 100%;
  border-radius: 50%;
  background-color: white;
  z-index: 0;
  &:before {
    position: absolute;
    content: "";
    width: 80%;
    height: 80%;
    top: 10%;
    left: 10%;
    background-color: white;
    border-radius: 50%;
    z-index: -1;
  }

  &:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #fff;
    background-image: linear-gradient(
      to right,
      red 0%,
      #ff7f00 25%,
      #ffe5aa 50%,
      #55fcf6 75%,
      #9bff44 100%
    );
    border-radius: 50%;
    z-index: -2;
  }
}
.blue_oval {
  border: 4px solid #d2bfa5 !important;
}
.violetblue_oval {
  border: 4px solid #735d55 !important;
}

.text-caption {
  margin-left: 10px;
}

.text-caption .first {
  margin-left: 0;
}

.errors-red {
  background: #ff5252 !important;
}

.errors-green {
  background: #4caf50 !important;
}

.reprint-btn {
  width: 70px;
  min-width: 70px !important;
  margin-top: 15px;
  border: 2px solid lightgray;
  background-color: white !important;
  border-radius: 0;
}

.total-quantity {
  position: absolute;
  width: 25px;
  height: 25px;
  top: -20px;
  right: -30px;
  border-radius: 50%;
  background: #ff5252;
  color: #fff;
  font-size: 12px;
  line-height: 25px;
  text-align: center;
}

@media screen and (max-width: 1024px) {
  .mobile-flex-div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;

    .text-caption {
      margin-left: 0;
      margin-top: 5px;
    }

    .text-caption .first {
      margin-left: 0;
      margin-top: 5px;
    }
  }
  .align-items-center {
    align-items: center;
  }
  .justify-content-around {
    justify-content: space-around;
  }
}
@media screen and (max-width: 767px) {
  .mobile-view-padding {
    margin-left: 0 !important;
  }
  .mobile-view-padding .col-12 {
    padding: 12px 5px 12px 4px;
  }
}
@media screen and (max-width: 320px) {
  .mobile-view-padding .col-12 {
    padding: 12px;
  }
}
</style>
